<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="row m-0 col-md-12 p-0 formborder">
  <form
    #df="ngForm"
    novalidate
    (keydown.enter)="onSearchPendingAuth()"
    class="w-100"
  >
    <div class="row">
      <div class="col-md-3 mb-2">
        <span>Voucher Date From</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="VoucherDateFrom"
            id="VoucherDateFrom"
            [max]="Search.VoucherDateTo || null"
            class="form-control input-text-css"
            [(ngModel)]="Search.VoucherDateFrom"
            (dateChange)="onDateChange('from')"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>

      <div class="col-md-3 mb-2">
        <span>Voucher Date To</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="VoucherDateTo"
            id="VoucherDateTo"
            [min]="Search.VoucherDateFrom || null"
            [max]="
              Search.VoucherDateFrom ? add30Days(Search.VoucherDateFrom) : null
            "
            class="form-control input-text-css"
            [(ngModel)]="Search.VoucherDateTo"
            (dateChange)="onDateChange('to')"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>

      <div class="col-md-3 mb-2">
        <span>Voucher Type</span>
        <select
          name="VoucherType"
          id="VoucherType"
          class="form-control input-text-css"
          [(ngModel)]="Search.VoucherType"
        >
          <option value="">Select Voucher Type</option>
          <option value="1">Receipt</option>
          <option value="2">Payment</option>
          <option value="3">Journal</option>
          <option value="4">Contra</option>
        </select>
      </div>

      <div class="col-md-3 mb-2">
        <span>Voucher Subtype</span>
        <select
          name="VoucherSubType"
          id="VoucherSubType"
          class="form-control input-text-css"
          [(ngModel)]="Search.VoucherSubType"
        >
          <option value="">Select Voucher Subtype</option>
          <option value="1">Loan</option>
          <option value="2">Accounting</option>
          <option value="3">Partner</option>
        </select>
      </div>

      <div class="col-md-3 mb-2">
        <span>Status</span>
        <select
          name="st"
          [(ngModel)]="Search.Status"
          class="form-control form-select"
        >
          <option value="Authorization Pending" selected>
            Authorization Pending
          </option>
          <option value="">All</option>
          <option value="Authorized">Authorized</option>
          <option value="Rejected">Rejected</option>
          <option value="Deleted">Deleted</option>
        </select>
      </div>

      <div class="col-md-2 text-right mb-2">
        <button
          type="button"
          (click)="onSearchPendingAuth()"
          class="btn font-size-12 button-btn"
          [disabled]="!df.form.valid"
        >
          Search
        </button>
      </div>

      <div class="col-md-3 mt-4" [hidden]="!dataSource">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
</div>

<div class="mt-3" *ngIf="dataSource">
  <div class="">
    <div class="table-responsive">
      <mat-table
        [dataSource]="dataSource"
        matSort
        matTableExporter
        #exporter="matTableExporter"
        style="max-width: 100%; overflow: auto"
      >
        <ng-container matColumnDef="Select">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            <ng-container *ngIf="hasAuthorizationPending()">
              <mat-checkbox
                name="Select"
                id="Select"
                [(ngModel)]="SelectAll"
                (change)="checkUncheckAll($event)"
                [checked]="IsSelected"
              ></mat-checkbox>
            </ng-container>
          </mat-header-cell>

          <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
            <ng-container
              *ngIf="row.Voucher_Status === 'Authorization Pending'"
            >
              <mat-checkbox
                class="example-margin"
                name="IsSelected{{ i }}"
                id="IsSelected{{ i }}"
                [(ngModel)]="row.IsSelected"
                [checked]="row.IsSelected"
              ></mat-checkbox>
            </ng-container>
          </mat-cell>

          <mat-footer-cell
            *matFooterCellDef
            style="max-width: 3.125rem"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="VoucherId">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            style="max-width: 3.75rem"
            *matHeaderCellDef
            >#</mat-header-cell
          >
          <mat-cell
            *matCellDef="let row; let i = index"
            class="grid-cell"
            style="max-width: 3.75rem; max-height: 0.3125rem"
          >
            {{ paginator?.pageIndex * paginator?.pageSize + (i + 1) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Voucher_Date">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Voucher Date
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Voucher_Date }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Voucher_Type">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Voucher Type</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Voucher_Type }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Voucher_Sub_Type">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Voucher Sub Type</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Voucher_Sub_Type }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Voucher_CreateBy">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Create By</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Voucher_CreateBy }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Voucher_CreateOn">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Create On</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Voucher_CreateOn }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Amount">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Amount</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Amount }}
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumnsModel; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsModel"></mat-row>
      </mat-table>

      <div class="row m-0 pt-2 pb-1">
        <div class="col-md-2">
          <button
            class="mt-3 btn font-size-12 button-btn"
            (click)="exportPendingAuthTable(exporter)"
          >
            <i
              class="fa fa-file-export mr-1"
              style="font-size: medium; cursor: pointer"
            ></i>
            Export
          </button>
        </div>
        <div class="col-md-4 mt-3">
          <mat-paginator
            #paginator
            [pageSizeOptions]="[20, 50]"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
        <div class="col-md-3">
          <div class="row m-0">
            <div class="col-md-12 text-right mt-3">
              <button
                type="button"
                (click)="OnApproved()"
                class="mt-3 btn font-size-12 button-btn"
                [disabled]="!hasAnyRowSelected()"
              >
                Authorized
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row m-0">
            <div class="col-md-12 text-right mt-3">
              <button
                type="button"
                (click)="OnReject()"
                class="mt-3 btn font-size-12 button-btn"
                [disabled]="!hasAnyRowSelected()"
              >
                Reject
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
